export const workspaceVersionObj = {workspaceVersion: 2};
Object.freeze(workspaceVersionObj);
